import React from 'react';

const ClientPerfil: React.FC = () => {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-wrap justify-between gap-3 items-center">
                <div className="flex min-w-72 flex-col gap-1">
                    <p className="text-slate-900 dark:text-white text-3xl font-bold leading-tight tracking-[-0.02em]">Meu Perfil</p>
                    <p className="text-slate-500 dark:text-slate-400 text-base font-normal leading-normal">Gerencie suas informações pessoais.</p>
                </div>
            </div>
            <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6">
                <p className="text-slate-500 dark:text-slate-400">Detalhes do perfil...</p>
            </div>
        </div>
    );
};

export default ClientPerfil;
